import { render, staticRenderFns } from "./ClientAddModal.vue?vue&type=template&id=bda5c6ac&scoped=true&"
import script from "./ClientAddModal.vue?vue&type=script&lang=js&"
export * from "./ClientAddModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bda5c6ac",
  null
  
)

export default component.exports